import { graphql } from '@/gql'

export const DeleteWorkflowMutation = graphql(/* GraphQL */ `
  mutation DeleteWorkflow($input: DeleteWorkflowInput!) {
    deleteWorkflow(input: $input) {
      id
    }
  }
`)
